import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/amazon': {
    width: 447,
    height: 512,
    paths: [
      {
        d: 'M257.2 162.7c0-39.3 5.2-69.2-35.5-69.1 0 0-37.9 0-54.2 49.5l-73.5-6.8c0-49.3 46.7-104.3 134.7-104.3 87.8 0 112.3 57 112.3 82.3v147.1c0 27.5 32.3 52.8 32.3 52.8l-56.8 56c-9.9-9.3-38.8-36.6-45.3-46.8-45.2 70.8-183.5 66.3-183.5-43.2 0-102 120.8-115.7 169.5-117.5zM257.2 249.5v-40.6c-33.7 1.1-84.2 10.6-84.2 57.8 0 50.8 84.2 62.8 84.2-17.2zM393.2 413c-7.7 10-70 67-174.5 67s-184.5-71.5-209-101c-6.8-7.7 1-11.3 5.5-8.3 73.3 44.5 187.8 117.8 372.5 30.3 7.5-3.7 13.3 2 5.5 12zM433 415.2c-6.5 15.8-16 26.8-21.2 31-5.5 4.5-9.5 2.7-6.5-3.8s19.3-46.5 12.7-55c-6.5-8.3-37-4.3-48-3.2-10.8 1-13 2-14-0.3-2.3-5.7 21.7-15.5 37.5-17.5 15.7-1.8 41-0.8 46 5.7 3.7 5.1 0 27.1-6.5 43.1z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/brands/amazon.js
// module id = null
// module chunks = 